module.exports = __webpack_public_path__ + "static/img/loongDance.0ab3f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/loongDance.png
// module id = +g69
// module chunks = 26